import React from 'react';
import PropTypes from 'prop-types';
import { useGuideConfig } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui';
import LayoutRenderer from '@ignitesales/neuro-application/src/neuro-guide/components/QuestionGroups/layouts/LayoutRenderer';
import IntegrationForm from './IntegrationForm';

const ActionModal = ({ action, isOpen, onClose, context = {} }) => {
  const { layouts } = useGuideConfig();
  const { targetType } = action || {};

  const layout = targetType === 'layout' && action?.layoutId && layouts ?
    layouts.find(l => String(l.id) === String(action.layoutId)) : null;

  const width = layout?.width;
  const height = layout?.height;

  const modalStyle = {};
  if (width) modalStyle.width = width;
  if (height) modalStyle.height = height;

  // Remove default modal padding for layouts so they fill the modal completely
  if (targetType === 'layout') {
    modalStyle.padding = '0';
    modalStyle.backgroundColor = 'transparent';
    modalStyle.boxShadow = 'none'; // Remove default shadow if any, as layout might handle it or we want a clean look
    // Do not set overflow: hidden on modalStyle to avoid clipping the close button
  }

  const renderContent = () => {
    if (targetType === 'integration') {
      return <IntegrationForm action={action} context={context} onClose={onClose} />;
    } else if (targetType === 'layout') {
      return <LayoutRenderer action={action} context={context} isPopup={true} />;
    }

    return null;
  };

  const dismissable = layout?.hideCloseButton !== true;

  return (
    <Modal
      show={isOpen}
      className={`action-modal ${targetType === 'layout' ? 'action-modal--layout' : ''}`}
      onClose={onClose}
      closeBtn={<i className="ion-md-close" />}
      nodeId="root"
      dismissable={dismissable}
      style={modalStyle}
      contentStyle={targetType === 'layout' ? { height: '100%', borderRadius: '5px', overflow: 'hidden', backgroundColor: 'transparent', boxShadow: 'none' } : undefined}
    >
      {renderContent()}
    </Modal>
  );
};

ActionModal.propTypes = {
  action: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  context: PropTypes.object
};

export default ActionModal;



